export const BRAND = {
  name: "Agenzia Funebre per Animali",
  phone: "389 244 6910",
  phoneHref: "tel:+393892446910",
  wa: "393892446910",
  address: "Via Leonardo Greppi, 12/A – 00149 Roma (RM)",
  email: "info@agenziafunebreperanimali.it",
  site: "https://www.agenziafunebreperanimali.it",
};

export const LOGO = "/logo.png";

export const IMG = {
  urne: "/img/urne.jpg",
  sala: "/img/sala.jpg",
  trasporto: "/img/trasporto.jpg",
  ricordo: "/img/ricordo.jpeg",
  area: "/img/area.png",
};

export const LISTINO = [
  { id: "xs", label: "Piccolissima taglia", range: "Fino a 5 kg", price: 400, max: 5 },
  { id: "s", label: "Piccola taglia", range: "Da 6 a 10 kg", price: 450, max: 10 },
  { id: "m", label: "Media taglia", range: "Da 11 a 20 kg", price: 500, max: 20 },
  { id: "l", label: "Grande taglia", range: "Da 21 a 30 kg", price: 550, max: 30 },
  { id: "xl", label: "Grandissima taglia", range: "Da 31 a 35 kg", price: 600, max: 35 },
  { id: "xxl", label: "Oltre i 35 kg", range: "Oltre i 35 kg", price: null, max: Infinity },
];

export const IVA = 22;

export const tierForWeight = (kg) => {
  const w = Number(kg);
  if (!w || w <= 0) return null;
  return LISTINO.find((t) => Math.ceil(w) <= t.max) || LISTINO[LISTINO.length - 1];
};

export const SPECIES = ["Cane", "Gatto", "Coniglio", "Furetto", "Uccello", "Roditore", "Rettile", "Altro"];

export const SERVICES = {
  singola: "Cremazione singola",
  multipla: "Cremazione collettiva",
  smaltimento: "Smaltimento",
};

export const STATUS = {
  in_attesa: { label: "In attesa", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  confermato: { label: "Confermato", cls: "bg-sky-50 text-[#0D3B52] border-sky-200" },
  completato: { label: "Completato", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  annullato: { label: "Annullato", cls: "bg-stone-100 text-stone-500 border-stone-200" },
};

export const PAY_STATUS = {
  saldato: { label: "Saldato", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  acconto: { label: "Acconto", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  da_pagare: { label: "Da pagare", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const waLink = (phone, text) => {
  let p = (phone || "").replace(/\D/g, "");
  if (p.startsWith("00")) p = p.slice(2);
  if (p && !p.startsWith("39") && p.length <= 10) p = `39${p}`;
  return `https://wa.me/${p}?text=${encodeURIComponent(text)}`;
};
